import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  GuardResult,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { ClientUserService, HashService } from 'src/app/services';

export const projectAuthGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<GuardResult> => {
  const router = inject(Router);
  const userService = inject(ClientUserService);
  const hashService = inject(HashService);

  try {
    const projectId = hashService.decode<number>(route.params['projectid']);
    const loggedIn = await userService.isLoggedIn();
    const clientIds = await userService.initTenantId();

    if (projectId && loggedIn && clientIds.tenantId) {
      return true;
    }

    if (loggedIn) {
      await userService.logout();
    }
  } catch (ex) {
    // ignore
  }

  return router.createUrlTree(['/', 'login'], {
    queryParams: { id: route.params['projectid'] },
  });
};
